import { ApiName } from '@periscopes/general/ApiName';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { DeploymentStatusTag } from '@ui/tags';
import { LoadingSpinner } from '@ui/LoadingSpinner';
import React from 'react';
import { SalesforceDescription } from '@ui/text';
import { usePeriscopeMetadata } from '@hooks';
import { GoToDictionaryButton, InformationSection, IngestedBySection, PopulatedBySection } from '@periscopes/general';
import { InlineCheckmarkMetadata, InlineMetadata } from '@periscopes/general/metadata';
import { SonarObjectType } from '@sonar-software/sonar-ts-types';
export const EntityInformation = ({ sonarObjectId }) => {
    const { loading, metadata } = usePeriscopeMetadata(sonarObjectId, SonarObjectType.SalesforceEntity);
    if (loading) {
        return React.createElement(LoadingSpinner, null);
    }
    return (React.createElement(InformationSection, { headerAction: React.createElement(GoToDictionaryButton, { sonarObjectId: sonarObjectId }), sonarObjectId: sonarObjectId },
        React.createElement(ApiName, { sonarObjectId: sonarObjectId }),
        React.createElement(SalesforceDescription, { sonarObjectId: sonarObjectId }),
        React.createElement(InlineCheckmarkMetadata, { label: COPY_SPECIFIC.ENABLE_REPORTS, value: metadata === null || metadata === void 0 ? void 0 : metadata.allowReports }),
        React.createElement(InlineCheckmarkMetadata, { label: COPY_SPECIFIC.TRACK_ACTIVITIES, value: metadata === null || metadata === void 0 ? void 0 : metadata.allowActivities }),
        React.createElement(InlineCheckmarkMetadata, { label: COPY_SPECIFIC.TRACK_FIELD_HISTORY, value: metadata === null || metadata === void 0 ? void 0 : metadata.trackFieldHistory }),
        React.createElement(InlineMetadata, { label: COPY_SPECIFIC.DEPLOYMENT_STATUS },
            React.createElement(DeploymentStatusTag, { status: metadata === null || metadata === void 0 ? void 0 : metadata.deploymentStatus })),
        React.createElement(IngestedBySection, { sonarObjectId: sonarObjectId }),
        React.createElement(PopulatedBySection, { sonarObjectId: sonarObjectId })));
};
